module.exports = __webpack_public_path__ + "img/banner2.9efb6bc3.jpg";